import { useEffect, useState } from 'react';
import { iconePara } from '../assets/items';
import { deveTingirIcone, iconeTingido } from '../look/iconeMaterial';

/**
 * URL do ícone já com a cor do material (`katana@valorite`, `bow@oak`). Enquanto tinge, devolve
 * a arte original; o padrão (Iron, madeira comum) nunca passa pelo canvas.
 */
export function useIconeTingido(id: string | null | undefined, qty?: number): string {
  const original = id ? iconePara(id, qty) : '';
  const [src, setSrc] = useState(original);
  useEffect(() => {
    if (!id || !deveTingirIcone(id)) {
      setSrc(original);
      return;
    }
    let vivo = true;
    void iconeTingido(id, qty).then(url => { if (vivo) setSrc(url); });
    return () => { vivo = false; };
  }, [id, qty, original]);
  return src;
}
